export var NodeType;
(function (NodeType) {
    /* survey */
    NodeType["AdditionalPriceLink"] = "price-link";
    NodeType["PipedResponse"] = "piped";
    NodeType["TemplateCategory"] = "category";
    NodeType["TemplateNode"] = "template-value";
    NodeType["TemplateTarget"] = "target";
    NodeType["TemplateCompetitor"] = "competitor";
    NodeType["TPP"] = "tpp";
    NodeType["ViewStimulus"] = "view-stimulus";
    NodeType["ViewTPP"] = "view-tpp";
    NodeType["ViewTPP_RT"] = "view-tpp-rt";
    NodeType["FindAndReplace"] = "find-and-replace";
    /* end survey */
    NodeType["BulletList"] = "bulletList";
    NodeType["Doc"] = "doc";
    NodeType["ListItem"] = "listItem";
    NodeType["Paragraph"] = "paragraph";
    NodeType["Text"] = "text";
    NodeType["Image"] = "image";
})(NodeType || (NodeType = {}));
